import React from 'react';
const STUDIO = {
  phone: '517-220-0621'
};
export function ContactFormHeader() {
  return <>
      <h2 className="text-3xl md:text-4xl text-ink mb-2" data-id="element-867">Send Us a Message</h2>
      <p className="text-gray-warm mb-8" data-id="element-868">
        Pick a topic, tell us what you need, and Storm will get back to you. For
        the fastest reply, call{' '}
        <a href={`tel:${STUDIO.phone}`} className="font-bold text-storm-red hover:underline" data-id="element-869">
          {STUDIO.phone}
        </a>
        .
      </p>
    </>;
}